module.exports = __webpack_public_path__ + "static/media/user.55a08fa9.png";